var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.componentType,{tag:"component",attrs:{"fieldName":_vm.fieldName,"loading":_vm.loading,"options":_vm.options,"uniqueId":_vm.uniqueId,"disabled":_vm.disabled,"optionLabel":"label"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }